import { ILandingProcessedPlanningFetched } from 'partner360/models/landing/ILandingProcessedPlanningFetched'
import { LandingOffering } from 'partner360/models/landing/LandingOffering'

interface IGetFetchedProcessesFilteredByOffering {
  processes: ILandingProcessedPlanningFetched[]
  offeringsOrder: LandingOffering[]
}

export const getProcessesSortedByOfferings = ({
  processes,
  offeringsOrder,
}: IGetFetchedProcessesFilteredByOffering) => {
  const offeringPriority = new Map<LandingOffering, number>()
  offeringsOrder.forEach((offering, index) => {
    offeringPriority.set(offering, index)
  })

  return processes.sort((a, b) => {
    if (a.partnerId !== b.partnerId) {
      return a.partnerId.localeCompare(b.partnerId)
    }

    const aOfferingPriority = offeringPriority.get(a.offering) ?? Infinity
    const bOfferingPriority = offeringPriority.get(b.offering) ?? Infinity

    return aOfferingPriority - bOfferingPriority
  })
}
